module.exports = __webpack_public_path__ + "static/media/user-3.118d86c4.jpg";